<template>
    <div>
        <div class="caz-complete-card__grid">
            <div>
                <div class="caz-complete-card__card">
                    <div class="caz-complete-card__inner" v-if="vehicle.permitted">
                        <div class="caz-complete-card__content" v-if="vehicle.permitted.hasFees == false">
                            <div class="caz-complete-card__heading-wrapper">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 35">
                                    <path
                                        fill="#00B67A"
                                        d="M17.5 0C7.835 0 0 7.835 0 17.5S7.835 35 17.5 35 35 27.165 35 17.5A17.5 17.5 0 0 0 17.5 0Zm9.933 14.4147-10.5 9.625c-.6907.6334-1.7577.6102-2.4202-.0525l-5.25-5.25a1.75 1.75 0 1 1 2.4744-2.4745l4.0653 4.0653 9.2645-8.4927a1.7501 1.7501 0 0 1 2.366 2.5794Z"
                                    />
                                </svg>

                                <p class="caz-complete-card__heading">Your vehicle is clean air zone compliant</p>
                            </div>

                            <p class="caz-complete-card__text" v-if="vehicle.permitted.zone !== false">
                                You don't need to pay any fees* to drive in
                                {{ displayAddress }} because your vehicle meets the Government's emissions and safety standards.
                            </p>

                            <p class="caz-complete-card__text" v-if="vehicle.permitted.zone === false">Your entered location is not within a clean air zone, so any vehicle is eligible to drive through without having to pay a fee.</p>

                            <p class="caz-complete-card__text" v-if="vehicle.permitted.zone === false">
                                If you are planning to drive through one of the clean air zones below, your vehicle is eligible because it meets the Government's emissions and safety standards, so you can drive worry free without having to
                                pay any fees*
                            </p>

                            <ul class="caz-complete-card__list" v-if="vehicle.permitted.zone === false">
                                <li>Bath</li>
                                <li>Birmingham</li>
                                <li>Bradford</li>
                                <li>Bristol</li>
                                <li>Portsmouth</li>
                                <li>Newcastle</li>
                                <li>London</li>
                                <li>Sheffield</li>
                            </ul>

                            <p class="link link--has-icon" v-on:click="resetFlow">Check another location</p>

                            <p class="caz-complete-card__heading">Looking for an upgrade?</p>

                            <p class="caz-complete-card__text" v-if="vehicle.fuelType == 'Electric'">
                                If you're looking for an upgrade to your electric car, look no further than Stellantis &You UK. We have the latest, stunning electric models from a variety of brands to choose from including eye-catching
                                hatchbacks, dynamic SUV's and spacious saloons.
                            </p>

                            <p
                                class="caz-complete-card__text"
                                v-else-if="vehicle.fuelType == 'Petrol Hybrid' || vehicle.fuelType == 'Diesel Hybrid' || vehicle.fuelType == 'Petrol Plug-in Hybrid' || vehicle.fuelType == 'Diesel Plug-in Hybrid'"
                            >
                                If you're looking for an upgrade to your hybrid car, look no further than Stellantis &You UK. We have the latest, stunning hybrid models from a variety of brands to choose from. Each vehicle has the same
                                great specification with the added benefit of zero emissions when you drive in fully electric mode.
                            </p>

                            <p class="caz-complete-card__text" v-else>
                                Why not switch to an electric or hybrid for your next car? You can drive worry free into any city thanks to zero emission driving modes, plus you will benefit from a reduction in fuel costs, smooth, quiet driving and much more!
                            </p>

                            <div class="caz-complete-card__buttons">
                                <a
                                    v-if="vehicle.fuelType == 'Petrol Hybrid' || vehicle.fuelType == 'Diesel Hybrid' || vehicle.fuelType == 'Petrol Plug-in Hybrid' || vehicle.fuelType == 'Diesel Plug-in Hybrid'"
                                    href="/hybrid-cars"
                                    class="btn btn--primary caz-complete-card__button"
                                    v-on:click="analyticsEvents({label: 'Discover More - Hybrid', action: 'Clicked'})">
                                    <span class="caz-complete-card__button-text"> Discover More </span>
                                </a>

                                <a v-else href="/electric-vehicles" class="btn btn--primary caz-complete-card__button"
                                    v-on:click="analyticsEvents({label: 'Discover More - Electric', action: 'Clicked'})">
                                    <span class="caz-complete-card__button-text"> Discover More </span>
                                </a>

                                <a href="/car-valuation" class="btn btn--primary-inverted caz-complete-card__button"
                                    v-on:click="analyticsEvents({label: 'Car Valuation', action: 'Clicked'})">
                                    <span class="caz-complete-card__button-text"> Value My Car </span>
                                </a>
                            </div>
                        </div>

                        <div class="caz-complete-card__content" v-if="vehicle.permitted.hasFees == true">
                            <div class="caz-complete-card__heading-wrapper">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 35">
                                    <path
                                        fill="#b61c00"
                                        d="M17.5 0a17.5 17.5 0 1 1 0 35 17.5 17.5 0 0 1 0-35Zm4.3 10.26-4.04 4.03-4.02-4.03a1.75 1.75 0 1 0-2.48 2.48l4.38 4.37-4.38 4.38a1.75 1.75 0 0 0 .78 2.95l.15.04c.56.09 1.14-.1 1.55-.52l4.03-4.02 4.02 4.02a1.75 1.75 0 1 0 2.48-2.47l-4.38-4.38 4.38-4.37a1.75 1.75 0 1 0-2.48-2.48Z"
                                    />
                                </svg>

                                <p class="caz-complete-card__heading">Your vehicle isn't clean air zone compliant</p>
                            </div>

                            <p class="caz-complete-card__text" v-if="vehicle.permitted.zone !== false">
                                You will need to pay a fee to drive in
                                {{ displayAddress }} because your vehicle doesn't meet the Government's emissions and safety standards.
                            </p>

                            <p class="caz-complete-card__text" v-if="vehicle.permitted.zone === false">Your entered location is not within a clean air zone, so any vehicle is eligible to drive through without having to pay a fee.</p>

                            <p class="caz-complete-card__text" v-if="vehicle.permitted.zone === false">
                                If you are planning to drive through a clean air zone, you will need to pay a fee because your vehicle doesn't meet the Government's emissions and safety standards. To find out the price for one of these
                                locations please use the link below:
                            </p>

                            <p class="link link--has-icon" v-on:click="resetFlow">Check another location</p>

                            <div class="caz-complete-card__fees" v-if="vehicle.permitted.zone !== false">
                                Clean Air Zone Charge
                                <span>{{ vehicle.permitted.fee }} </span>
                            </div>

                            <p class="caz-complete-card__heading">Looking for an upgrade?</p>

                            <p class="caz-complete-card__text" v-if="vehicle.fuelType == 'Electric'">We have the latest electric cars available so you can drive worry-free...</p>

                            <p class="caz-complete-card__text" v-else>
                                Why not switch to an electric or hybrid for your next car? You can drive worry free into any city thanks to zero emission driving modes, plus you will benefit from a reduction in fuel costs, smooth, quiet driving and much more!
                            </p>

                            <div class="caz-complete-card__buttons">
                                <a
                                    v-if="vehicle.fuelType == 'Petrol Hybrid' || vehicle.fuelType == 'Diesel Hybrid' || vehicle.fuelType == 'Petrol Plug-in Hybrid' || vehicle.fuelType == 'Diesel Plug-in Hybrid'"
                                    href="/hybrid-cars"
                                    class="btn btn--primary caz-complete-card__button"
                                    v-on:click="analyticsEvents({label: 'Discover More - Hybrid', action: 'Clicked'})">
                                    <span class="caz-complete-card__button-text"> Discover More </span>
                                </a>

                                <a v-else href="/electric-vehicles" class="btn btn--primary caz-complete-card__button"
                                    v-on:click="analyticsEvents({label: 'Discover More - Electric', action: 'Clicked'})">
                                    <span class="caz-complete-card__button-text"> Discover More </span>
                                </a>

                                <a href="/car-valuation" class="btn btn--primary-inverted caz-complete-card__button"
                                    v-on:click="analyticsEvents({label: 'Car Valuation', action: 'Clicked'})">
                                    <span class="caz-complete-card__button-text"> Value My Car </span>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div class="caz-complete-card__inner" v-else>
                        <LoadingSpinner />
                    </div>

                    <div class="caz-complete-card__inner">
                        <div class="caz-complete-card__check-another">
                            <div ref="mapEl" class="caz-complete-card__map"></div>

                            <p class="caz-complete-card__text terms">
                                *The compliance results from the Stellantis &You clean air checker are based on the Government standards delivered by the national archives. Stellantis &You do not guarantee their accuracy and the results
                                should not be relied upon. You can also check your vehicle on the gov.uk website here.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="caz-complete-card__vehicle-details">
                <VehicleDetails />
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import VehicleDetails from "../VehicleDetails";
import PreviousStep from "../PreviousStep";
import LoadingSpinner from "../../../../core/components/LoadingSpinner.vue";
import { customEvent } from "../../../../modules/tracking/AnalyticsEvents";

export default {
    components: {
        VehicleDetails,
        PreviousStep,
        LoadingSpinner,
    },
    data() {
        return {
            googleClass: null,
        };
    },
    computed: {
        ...mapState(["navigator", "vehicle", "location", "place"]),
        ...mapGetters(["currentStep"]),
        displayAddress() {
            if (!this.place) {
                console.error("No place data");
                return;
            }

            const town = this.place.address_components.find((component) => component.types[0] === "postal_town");

            const locality = this.place.address_components.find((component) => component.types[0] === "locality");

            if (town) {
                return town.long_name;
            } else if (locality) {
                return locality.long_name;
            } else {
                return this.place.formatted_address;
            }
        },
    },
    methods: {
        initMap(el) {
            window.GoogleMapsLoader.getMap().then((google) => {
                this.googleClass = google;

                const map = new google.maps.Map(el, {
                    center: { lat: 51.5033998, lng: -0.1277265 },
                    zoom: 12,
                });

                if (this.location) {
                    map.setCenter(this.location);

                    const markerData = {
                        position: this.location,
                        map: map,
                    };
                    const marker = new google.maps.Marker(markerData);
                }

                const files = [
                    "/js/clean-air-zone/Ultra_Low_Emission_Zone_(ULEZ).geojson",
                    "/js/clean-air-zone/Bath CAZ 2020.geoJSON",
                    "/js/clean-air-zone/Birmingham CAZ 2020.geoJSON",
                    "/js/clean-air-zone/Bradford CAZ 2021.geoJSON",
                    "/js/clean-air-zone/Bristol CAZ 2021.geoJSON",
                    "/js/clean-air-zone/Newcastle CAZ 2021.geoJSON",
                    "/js/clean-air-zone/Portsmouth CAZ 2021.geoJSON",
                    "/js/clean-air-zone/Sheffield CAZ.geoJSON",
                    "/js/clean-air-zone/London CCZ_ULEZ 2019.geoJSON",
                ];

                files.forEach(file => {
                    map.data.loadGeoJson(file);
                })
                map.data.setStyle(function(feature) {
                    return {
                        strokeColor: feature.getProperty('stroke'),
                        strokeOpacity: feature.getProperty('stroke-opacity'),
                        strokeWeight: feature.getProperty('stroke-width'),
                        fillColor: feature.getProperty('fill'),
                        fillOpacity: feature.getProperty('fill-opacity'),
                    }
                });
            });
        },
        resetFlow() {
            this.analyticsEvents({
                label: "Reset Flow",
                action: "Clicked",
            });
            window.scrollTo(0, 0);
            this.$store.dispatch("resetFlow");
        },
        analyticsEvents(data) {
            customEvent({
                category: "Clean Air Zone",
                label: data.label,
                action: data.action,
            });
        }
    },
    mounted() {
        window.scrollTo(0, 0);
        this.initMap(this.$refs.mapEl);
    },
};
</script>

<style lang="scss" scoped>
.caz-complete-card {
    &__grid {
        margin-top: 37px;
        display: grid;
        grid-template-columns: 1fr;
        gap: 15px;
    }

    @media (min-width: 768px) {
        &__grid {
            grid-template-columns: 2fr 1fr;
        }
    }

    &__card {
        box-shadow: 0px 11px 24px rgba(0, 0, 0, 0.07);
        border-radius: 10px;
        border-top: 10px solid #0293d6;
        margin-left: auto;
        margin-right: auto;
        width: 100%;
        height: min-content;
    }

    &__title {
        font-weight: 700;
        font-size: 20px;
        line-height: 20px;
        color: #192a44;
        margin-top: 38px;
        margin-bottom: 30px;
    }

    &__fees {
        font-size: 16px;
        background-color: #e5f4fa;
        border-radius: 10px;
        padding: 15px;

        & > span {
            font-weight: 700;
            color: #0093d6;
            margin-left: 10px;
        }
    }

    &__inner {
        display: grid;
        grid-template-columns: 1fr;
        align-items: center;
        padding: 25px;
        padding-bottom: 0;
        background-color: white;
        border-radius: 0 0 10px 10px;
        height: 100%;

        &:last-of-type {
            padding-top: 0;
            padding-bottom: 25px;
        }
    }

    &__heading-wrapper {
        display: grid;
        grid-template-columns: minmax(0, 35px) 1fr;
        align-items: center;
        gap: 15px;

        & > svg {
            width: 35px;
            height: 35px;
        }
    }

    &__list {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    }

    &__heading {
        font-weight: 700;
        font-size: 16px;
        line-height: 24px;
        color: #4a4a4a;
    }

    &__input {
        background-color: #f7f7f7;
    }

    &__button {
        margin-top: 20px;
        min-width: 100%;
    }

    @media (min-width: 768px) {
        &__button {
            margin-bottom: 20px;
            min-width: unset;

            & + & {
                margin-left: 15px;
            }
        }
    }

    &__vehicle-details {
        display: none;
    }

    @media (min-width: 768px) {
        &__vehicle-details {
            display: block;
        }
    }

    &__map {
        width: 100%;
        padding-bottom: 60%;
        margin-top: 20px;
        margin-bottom: 20px;
    }
}

.link {
    cursor: pointer;

    &:hover {
        text-decoration: underline;
        text-decoration-color: #0293d6;
        text-underline-offset: 4px;
        text-decoration-thickness: 3px;
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/cms-content-slices/components/clean-air-zone/steps/Complete.vue